import { orderService } from "@/services/api/features/orderService";
import { executeAction } from "@/services/api/helpers";

export default {
  namespaced: true,

  state: {
    loading: {},
    error: {},
    purchaseHistory: [],
  },

  getters: {
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
    getPurchaseHistory : (state) => state.purchaseHistory
  },

  mutations: {
    SET_PURCHASE_HISTORY(state, purchaseHistory) {
      state.purchaseHistory = purchaseHistory;
    },
    SET_LOADING(state, { action, status }) {
      state.loading = { ...state.loading, [action]: status };
    },
    SET_ERROR(state, { action, message }) {
      state.error = { ...state.error, [action]: message };
    },
  },

  actions: {
    // ---------------   FOR ALL USER --------------------

    async getUserOrderList({ commit },status) {
      return executeAction({ commit, action: "getUserOrderList" }, () =>
        orderService.getUserOrderList(status),
        { success: (data) => commit("SET_PURCHASE_HISTORY", data.data) }
      );
    },
    async getChildOrderList({ commit },params) {
      return executeAction({ commit, action: "getChildOrderList" }, () =>
        orderService.getChildOrderList(params),
        { success: (data) => commit("SET_PURCHASE_HISTORY", data.data) }
      );
    },
    async cancelOrder({ commit },orderId) {
      return executeAction({ commit, action: "cancelOrder" }, () =>
        orderService.cancelOrder(orderId),
      );
    },
    async Payment({ commit },orderId) {
      return executeAction({ commit, action: "Payment" }, () =>
        orderService.Payment(orderId),
      );
    },
  },
};
